import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=fa064328&scoped=true&"
import script from "./subMenu.vue?vue&type=script&lang=js&"
export * from "./subMenu.vue?vue&type=script&lang=js&"
import style0 from "./subMenu.vue?vue&type=style&index=0&id=fa064328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa064328",
  null
  
)

export default component.exports